// Pesquisa as opções já autorizadas pelo backend ao abrir a janela de sessões.
export function buscarOpcoesAgendaSessoes({ ITENS = [], NOME = '', PAGINA = 1, QUANTIDADE = 25 } = {}) {
  const normalizar = valor => String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const termos = normalizar(NOME).split(/\s+/).filter(Boolean);
  const itens = ITENS.filter(item => termos.every(termo => normalizar(`${item.DESCRICAO} ${item.ID}`).includes(termo)));
  const quantidade = Math.max(1, Math.min(100, Number(QUANTIDADE) || 25));
  const inicio = (Math.max(1, Number(PAGINA) || 1) - 1) * quantidade;
  return { ITEMS: itens.slice(inicio, inicio + quantidade), QUANTIDADE_TOTAL: itens.length };
}
